export function maintenanceMessage(state = {}, action) {
  if (action && action.type) {
    switch (action.type) {
      case "MAINTENANCE_MESSAGE":
        return action.err;
      case "CLEAR_MAINTENANCE_MESSAGE":
        return "";
      default:
        return state;
    }
  }
}
